import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import InputContainer from './input-container';
import { InformationIcon, Theme } from '@spoiler-alert/ui-library';

const useStyles = createUseStyles({
  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.176px',
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.08px',
    textAlign: 'left',
    margin: [0, 0, 16, 0],
  },
  subtitleDescription: {
    fontSize: '12px',
    lineHeight: 1.33,
    fontWeight: 500,
    letterSpacing: 'normal',
    textAlign: 'left',
    marginBottom: 12,
  },
  subtitleInfo: {
    background: Theme.teal5,
    padding: 12,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginBottom: 16,
    marginTop: -12,
    borderRadius: 4,
    '& svg': {
      width: 16,
      height: 16,
      fill: Theme.teal,
    },
    '& span': {
      fontWeight: 400,
    },
  },
});

const formatForField = (field) => {
  if (field.includes('Revenue')) return 'money';
  if (field.includes('Weight')) return 'weight';
  return 'number';
};

const InputCard = ({ userMinimums, pickupMinimum, deliveryMinimum, setTouched, setMinimum, title }) => {
  const classes = useStyles();
  return (
    <div className={classes.row}>
      <h2 className={classes.title}>{title}</h2>
      <h2 className={classes.subtitle}>Delivery truck lane minimums</h2>
      <div className={classes.subtitleDescription}>Truck type</div>
      <InputContainer
        values={userMinimums[deliveryMinimum]}
        format={formatForField(deliveryMinimum)}
        setTouched={setTouched}
        onChange={(truckType, value) => setMinimum(deliveryMinimum, truckType, value)}
      />
      <hr />
      <h2 className={classes.subtitle}>Pickup truck lane minimums</h2>
      {!pickupMinimum.includes('Revenue') && (
        <div className={classes.subtitleInfo}>
          <InformationIcon />
          <span className={classes.subtitleDescription}>
            Buyers can set their own pickup trucklane minimums. If a buyer's minimum is higher than yours, it will override your setting below.
          </span>
        </div>
      )}
      <div className={classes.subtitleDescription}>Truck type</div>
      <InputContainer
        values={userMinimums[pickupMinimum]}
        format={formatForField(pickupMinimum)}
        setTouched={setTouched}
        onChange={(truckType, value) => setMinimum(pickupMinimum, truckType, value)}
      />
    </div>
  );
};

const TruckTypeMinimums = PropTypes.shape({
  dry: PropTypes.number,
  refrigerated: PropTypes.number,
  frozen: PropTypes.number,
});

export default InputCard;

InputCard.propTypes = {
  deliveryMinimum: PropTypes.string,
  pickupMinimum: PropTypes.string,
  userMinimums: PropTypes.shape({
    mode: PropTypes.string,
    deliveryRevenue: TruckTypeMinimums,
    pickupRevenue: TruckTypeMinimums,
    deliveryWeight: TruckTypeMinimums,
    pickupWeight: TruckTypeMinimums,
    deliveryPallets: TruckTypeMinimums,
    pickupPallets: TruckTypeMinimums,
  }),
  setMinimum: PropTypes.func,
  setTouched: PropTypes.func,
  title: PropTypes.string,
};
